import util from '../../lib/util';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import FlatFeeMilestone from '../../entities/flatFeeMilestone';
import Invoice from '../../entities/invoice';
import Task from '../../entities/task';

/*
 * Delete/nullify anywhere this flatFeeMilestone is used in other entities
 *
 * @param {FlatFeeMilestone} flatFeeMilestone
 */
export function deleteFlatFeeMilestone(flatFeeMilestone: FlatFeeMilestone, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = flatFeeMilestone.id;
    }
    /* Simple delete usages */
        
    store.getState().invoices
        .getMappingFor('flatFeeMilestoneId', flatFeeMilestone.id)
        .filter(invoiceTemp => invoiceTemp.status !== 'D')
        .forEach(invoiceTemp => {
            const _invoice = invoiceTemp.clone();
            _invoice.status =  'U';
            _invoice.addedOn = newHRTimestamp();
            _invoice.importSource = targetImportSource;
            _invoice.importId = mergeId;

            _invoice.flatFeeMilestoneIds = _invoice.flatFeeMilestoneIds?.filter(id => id !== flatFeeMilestone.id) || [];
            store.dispatch(Actions.InvoiceActions.saveInvoiceQueue(_invoice));
        });

    store.getState().tasks
        .getMappingFor('flatFeeMilestoneId', flatFeeMilestone.id)
        .filter(taskTemp => taskTemp.status !== 'D')
        .forEach(taskTemp => {
            const _task = taskTemp.clone();
            _task.status =  'U';
            _task.addedOn = newHRTimestamp();
            _task.addedBy = getCurrentUserId();
            _task.importSource = targetImportSource;
            _task.importId = mergeId;

            _task.flatFeeMilestoneBucket = null;
            store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
        });

    /* Remove the actual flatFeeMilestone */
    flatFeeMilestone.status = 'D';
    flatFeeMilestone.addedOn = newHRTimestamp();
    flatFeeMilestone.addedBy = getCurrentUserId();
    flatFeeMilestone.importSource = targetImportSource;
    flatFeeMilestone.importId = mergeId;
    store.dispatch(Actions.FlatFeeMilestoneActions.removeFlatFeeMilestoneQueue(flatFeeMilestone));
    
}

/*
 * Replace anywhere this flatFeeMilestone is used in other entities.
 *
 * @param {FlatFeeMilestone} flatFeeMilestone
 * @param {FlatFeeMilestone} replaceWith
 * @return {FlatFeeMilestone} - FlatFeeMilestone will have refs stripped away
 */
export function replaceFlatFeeMilestone(flatFeeMilestone: FlatFeeMilestone, replaceWith: FlatFeeMilestone, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = flatFeeMilestone.id;
    }
    /* Simple replace usages */
        
    store.getState().invoices
        .getMappingFor('flatFeeMilestoneId', flatFeeMilestone.id)
        .filter(invoiceTemp => invoiceTemp.status !== 'D')
        .forEach(invoiceTemp => {
            const _invoice = invoiceTemp.clone();
            _invoice.status =  'U';
            _invoice.addedOn = newHRTimestamp();
            _invoice.importSource = targetImportSource;
            _invoice.importId = mergeId;

            _invoice.flatFeeMilestoneIds = _invoice.flatFeeMilestoneIds?.map(id => (id === flatFeeMilestone.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.InvoiceActions.saveInvoiceQueue(_invoice));
        });

    store.getState().tasks
        .getMappingFor('flatFeeMilestoneId', flatFeeMilestone.id)
        .filter(taskTemp => taskTemp.status !== 'D')
        .forEach(taskTemp => {
            const _task = taskTemp.clone();
            _task.status =  'U';
            _task.addedOn = newHRTimestamp();
            _task.addedBy = getCurrentUserId();
            _task.importSource = targetImportSource;
            _task.importId = mergeId;

            _task.flatFeeMilestoneBucket = replaceWith.id;
            store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
        });

    return flatFeeMilestone;
}

/*
 * Determine the impact of deleting this flatFeeMilestone from other entities
 *
 * @param {FlatFeeMilestone} flatFeeMilestone
 * @return {Array.<{count: number, entity: string}>} - a list of impacted entities, along with a count of impacted entities
 */
export function deleteImpactFlatFeeMilestone(flatFeeMilestone: FlatFeeMilestone) {
    const impacts: string[] = [];
    const state = store.getState();
    
    /* Simple delete usages */
        
    const invoiceFlatFeeMilestoneIdsImpact = state.invoices
          .getMappingFor('flatFeeMilestoneId', flatFeeMilestone.id)
          .filter(invoice => invoice.status !== 'D');

    invoiceFlatFeeMilestoneIdsImpact.forEach(() => impacts.push('invoices'));

    const taskFlatFeeMilestoneBucketImpact = state.tasks
          .getMappingFor('flatFeeMilestoneId', flatFeeMilestone.id)
          .filter(task => task.status !== 'D');

    taskFlatFeeMilestoneBucketImpact.forEach(() => impacts.push('tasks'));

    return util.countDistinct(impacts);
}